import { Component, Inject, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import * as atlas from 'azure-maps-control';
import { Project } from '../../shared/models/projects/project.model';
import { AuthenticationType } from 'azure-maps-control';
import { DomSanitizer } from '@angular/platform-browser';
import { ProjectService } from '../../core/services/project.service';
import { firstValueFrom, forkJoin } from 'rxjs';

declare var $: any;

@Component({
  selector: 'app-details',
  templateUrl: './details.component.html',
  styleUrls: ['./details.component.css']
})
export class DetailsComponent implements OnInit, OnDestroy {

  subscriptions: Subscription = new Subscription();
  key: string = '4WDQBD6oO6ENn5vpiJg1kMZrQzwtmMW3gOxupLXWeEW6FLexrRaFJQQJ99CEACYeBjFCIJONAAAgAZMP15xy';
  map: any;
  popup: any;
  datasource: any;
  searchLayer: any;
  project: any;
  features: any;
  shapes: any;
  baseUrl: string = '';
  iframeUrl: any;

  constructor(
    private router: ActivatedRoute,
    private projectService: ProjectService,
    private sanitizer: DomSanitizer) {
  }

  async ngOnInit() {

    var id = this.router.snapshot.queryParamMap.get('id');

    if (!id) {
      return;
    }

    //Get project
    this.project = await firstValueFrom(this.projectService.getProject(id));

    if (!this.project) {
      return;
    }

    this.iframeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.project.cameraUrl);

    //Initialize a map instance.
    this.map = new atlas.Map('myMap', {
      center: [this.project.location.longitude, this.project.location.latitude],
      zoom: 14,
      view: 'Auto',
      language: 'Auto',
      style: "grayscale_light",

      authOptions: {
        authType: AuthenticationType.subscriptionKey,
        subscriptionKey: this.key
      }
    });

    //Wait until the map resources are ready.
    this.map.events.add('ready', () => {

      //Create a data source and add it to the map.
      this.datasource = new atlas.source.DataSource();
      this.map.sources.add(this.datasource);

      this.datasource.add(new atlas.data.Feature(new atlas.data.Point([this.project.location.longitude, this.project.location.latitude]), {
        id: this.project.id,
        name: this.project.name,
        company: this.project.company,
        addressLine: this.project?.location?.address
      }));

      //Add a layer for rendering the results.
      this.searchLayer = new atlas.layer.SymbolLayer(this.datasource, 'layer', {
        iconOptions: {
          image: 'pin-red',
          anchor: 'center',
          allowOverlap: true
        }
      });
      this.map.layers.add(this.searchLayer);
    });
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
